module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('users', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbArray,
      "note": 'Invite and manage your location users.',
      "businessId": _vm.activeBusinessId,
      "locationId": _vm.activeLocationId,
      "baseRoute": '/app/my_location/users',
      "baseRouteName": 'My Location Users'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ed985ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyLocation/Users.vue
// module id = 447
// module chunks = 1